class ClientLogger {
  #importPromise;
  constructor(cb) {
    this.callback = cb;
    this.#importPromise = (async () => {
      let log = console.log;
      try {
        const { clerrLog } = await import(
          "https://a.sfdcstatic.com/digital/@sfdc-www/clientlibs-web-components/v1-stable/clientLogging.js"
        );
        log = clerrLog;
      } catch (e) {
        log("Unable to load clientLogging library", e, "info");
      }
      return log;
    })();
  }
  connect() {
    return this.#importPromise.then((log) => {
      this.callback?.(log);
      return log;
    });
  }
  disconnect() {}
  update() {}
}

export { ClientLogger };
